export default "assets/images/icons/linkedin-b55cc27d.svg";